// DeleteReviewModal.tsx
import React, { useState } from "react";
import axios from "axios";

type Props = {
    selectedReviewId: number | null;
    onDelete: (id: number) => void;
    BASE_URL: string;
};

const DeleteReviewModal = ({ selectedReviewId, onDelete, BASE_URL }: Props) => {
    const token = localStorage.getItem("token");
    const [deleting, setDeleting] = useState(false);

    const handleDelete = async () => {
        if (!selectedReviewId) return;

        setDeleting(true);
        try {
            await axios.delete(`${BASE_URL}/avaliacoes/${selectedReviewId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            // Atualiza a lista no frontend
            onDelete(selectedReviewId);

            // Fecha o modal e reseta seleção
            const modalEl = document.getElementById("delete_modal");
            if (modalEl) {
                const modalInstance = window.bootstrap.Modal.getInstance(modalEl);
                modalInstance?.hide();
            }

        } catch (err) {
            console.error("Erro ao deletar avaliação:", err);
            alert("Não foi possível deletar a avaliação.");
        } finally {
            setDeleting(false);
        }
    };

    return (
        <div
            className="modal fade"
            id="delete_modal"
            tabIndex={-1}
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered modal-sm">
                <div className="modal-content">
                    <div className="modal-body text-center">
                        <h5 className="mb-3">Delete Review</h5>
                        <p className="mb-3">
                            Are you sure you want to delete this review?
                        </p>
                        <div className="d-flex align-items-center justify-content-center">
                            <button
                                className="btn btn-light me-2"
                                data-bs-dismiss="modal"
                                disabled={deleting}
                            >
                                No
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={handleDelete}
                                disabled={deleting || !selectedReviewId}
                            >
                                {deleting ? "Deleting..." : "Yes"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteReviewModal;